module.exports = "#version 100\r\nprecision highp float;\r\n\r\nuniform mat4 u_viewProjectionMatrix;\r\n\r\nattribute vec3 a_position;\r\nattribute vec3 a_normal;\r\nattribute vec2 a_uv;\r\n\r\nvarying vec3 v_position;\r\nvarying vec3 v_normal;\r\nvarying vec2 v_uv;\r\n\r\nvoid main() {\r\n    gl_Position = u_viewProjectionMatrix * vec4(a_position, 1.0);\r\n    v_position = a_position;\r\n    v_normal = a_normal;\r\n    v_uv = a_uv;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/forward.vert.glsl
// module id = 33
// module chunks = 0